/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc
 */

export const uninstallAppRpc = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'uninstallApp',
  auth: 'app',
  fingerprint: '_9ePcO86XWixeh47ZVTbHMoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteAccountRpc = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'deleteAccount',
  auth: 'app',
  fingerprint: 'lrs_LE4qSMBeP1PtSIXotMoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserInstallInfosRpc = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'getUserInstallInfos',
  auth: 'app',
  fingerprint: 'nE17L21F-AuNZhsimSq_gsoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallAppForUserRpc = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'uninstallAppForUser',
  auth: 'app',
  fingerprint: 'GUWsuNcLJfOWOt0ZIQbQa8oxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstalledAppsWithAppPermissionsForDataClassificationRpc = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'getInstalledAppsWithAppPermissionsForDataClassification',
  auth: 'app',
  fingerprint: 'US8i6qI8Vx1BFcBMMgWySsoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};